import React, { FC } from 'react'
import './full-page-loader.scss'

const FullPageLoader: FC = () => (
  <div className="full-page-loader-container">
    <div className="loader">
      <div className="dot"></div>
      <div className="dot"></div>
      <div className="dot"></div>
      <div className="dot"></div>
      <div className="dot"></div>
    </div>
  </div>
)

export default FullPageLoader
